import { render } from "./NewsWindow.vue?vue&type=template&id=38dbc2b0&scoped=true"
import script from "./NewsWindow.vue?vue&type=script&lang=js"
export * from "./NewsWindow.vue?vue&type=script&lang=js"

import "./NewsWindow.vue?vue&type=style&index=0&id=38dbc2b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38dbc2b0"]])

export default __exports__